import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE } from "./config"; 
import socket from "../socket/socket";


function AutoMatch() {
  const { groupId } = useParams();

  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const runAutoPreview = useCallback(async (approveRecentEncounter = false) => {
    setLoading(true);
    setError('');
    setPreview(null);

    try {
      const res = await fetch(
        `${API_BASE}/api/game-match/auto-preview`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ groupId, approveRecentEncounter })
        }
      );

      const data = await res.json();
      if (
        res.status === 409 &&
        data.requiresRecentEncounterApproval &&
        !approveRecentEncounter
      ) {
        const pairs = Array.isArray(data.recentEncounterPairs)
          ? data.recentEncounterPairs
          : [];
        const names = pairs
          .map(pair => `${pair.nameA} ↔ ${pair.nameB}`)
          .join('\n');
        const approved = window.confirm(
          `ไม่มีชุดที่ไม่พบคนซ้ำใน 2 เกมล่าสุด\n${names}\n\n` +
          'ต้องการ Approve เพื่อสร้าง Preview นี้หรือไม่?'
        );
        if (approved) {
          await runAutoPreview(true);
          return;
        }
      }

      if (!res.ok || !data.ok) {
        throw new Error(data.message || 'Auto match failed');
      }

      setPreview(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [groupId]);


useEffect(() => {

  if (!groupId) return;

  console.log("📡 AutoMatch join-group:", groupId);

  socket.emit("join-group", Number(groupId));

  const handlePreview = (data) => {
    console.log("🔥 Preview received:", data);

    if (Number(data.groupId) === Number(groupId)) {
      runAutoPreview(); // reload preview
    }
  };

  const handleStarted = (data) => {
    console.log("🔥 Match started:", data);

    if (Number(data.groupId) === Number(groupId)) {
      setPreview(null);
      setInfo("🟢 Match started (Realtime)");
    }
  };

  const handleCancelled = (data) => {
    console.log("🔥 Match cancelled:", data);

    if (Number(data.groupId) === Number(groupId)) {
      setPreview(null);
    }
  };

  socket.on("match-preview", handlePreview);
  socket.on("match-started", handleStarted);
  socket.on("match-cancelled", handleCancelled);

  return () => {
    socket.off("match-preview", handlePreview);
    socket.off("match-started", handleStarted);
    socket.off("match-cancelled", handleCancelled);
  };

}, [groupId, runAutoPreview]);

  /* ===============================
     CONFIRM
  =============================== */
  const confirmMatch = async () => {
    if (!preview) return;

    try {
      const res = await fetch(
       `${API_BASE}/api/game-match/auto-confirm`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            matchId: preview.matchId,
            groupId
          })
        }
      );

      const data = await res.json();
      if (!data.ok) throw new Error(data.message);

 setInfo('🟢 Match นี้เริ่มแล้ว กดสุ่มเพื่อจัดรอบถัดไป');
   
    // 🔥 เคลียร์ค่าทั้งหมด เพื่อเริ่ม random ใหม่
    setPreview(null);
    setError('');
    setLoading(false);
    } catch (e) {
      alert(e.message);
    }
  };

  /* ===============================
     CANCEL
  =============================== */
  const cancelMatch = async () => {
    if (!preview) return;

    try {
      await fetch(
       `${API_BASE}/api/game-match/auto-cancel`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            matchId: preview.matchId,
            groupId
          })
        }
      );

      setPreview(null);
    } catch (e) {
      alert(e.message);
    }
  };

  /* ===============================
     RENDER
  =============================== */
  return (
    <div style={{ padding: 30 }}>
      <h2>🤖 Auto Match Preview</h2>

      <button onClick={() => runAutoPreview(false)} disabled={loading}>
        🔄 สุ่ม Auto Match
      </button>

      {error && (
        <div style={{ color: 'red', marginTop: 10 }}>
          ⚠ {error}
        </div>
      )}

{/* ✅ แสดง info เสมอ */}
{info && (
  <div style={{ color: 'green', marginTop: 10 }}>
    {info}
  </div>
)}
      {preview && (
        <>
          <hr />

          <h3>👥 ผลการจัดทีม</h3>

          <div style={{ display: 'flex', gap: 40 }}>
            <div>
              <b>Team 1 (รวม {preview.sum1})</b>
              <ul>
                {preview.team1.map(p => (
                  <li key={p.user_id}>
                    {p.name} ({p.point})
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <b>Team 2 (รวม {preview.sum2})</b>
              <ul>
                {preview.team2.map(p => (
                  <li key={p.user_id}>
                    {p.name} ({p.point})
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {preview.pairHistory?.length > 0 && (
            <>
              <h4>🔁 เคยเจอกันมาก่อน</h4>
              <ul>
                {preview.pairHistory.map((p, i) => (
                  <li key={i}>
                    {p.user_a} ↔ {p.user_b} : {p.pair_count} ครั้ง
                  </li>
                ))}
              </ul>
            </>
          )}

          <div style={{ marginTop: 20 }}>
            <button onClick={confirmMatch}>
              ✅ Confirm
            </button>{' '}
            <button onClick={cancelMatch}>
              ❌ Cancel
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default AutoMatch;
